// src/features/profile/HelpPage.jsx
import React from "react";
import "../../../styles/profilepage.css";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/icons/NewLogo.png";
import { useState } from "react";

const faqs = [
  "How do I reset my password?",
  "How can I contact customer support?",
  "How do I cancel or delete my account?",
  "Is my data secure and private?",
  "How do I use [feature name] or get started?",
  "Is there a free trial or how does the pricing work?",
];

function HelpPage() {
  const navigate = useNavigate();
  const [expandedIndex, setExpandedIndex] = useState(null);
  const toggleFAQ = (index) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };
  return (
    <div className="help-container">
      {/* 🔹 Flat Header */}
      <div className="help-header">
        <button className="help-back-button" onClick={() => navigate(-1)}>
          <IoIosArrowBack size={18} />
          <span></span>
        </button>
        <img src={logo} alt="Logo" className="archived-logo" />
      </div>

      <div className="help-content">
        <h3 className="faq-title">FAQ’s</h3>
        {faqs.map((question, index) => (
          <React.Fragment key={index}>
            <div className="faq-box" onClick={() => toggleFAQ(index)}>
              <span className="faq-question-text">
                {index + 1}. {question}
              </span>
              <span className="faq-plus">
                {expandedIndex === index ? "-" : "+"}
              </span>
            </div>

            {expandedIndex === index && (
              <div className="faq-answer">
                This is a placeholder answer for: "{question}"
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default HelpPage;
